import { jwtDecode } from "jwt-decode"
import moment from "moment"
import { create } from "zustand"
import { devtools } from "zustand/middleware"
import { fetchResource } from "../apis/request/request"
import { IWebSocket } from "../apis/request/socket"

type RoomState = {
  OrganizationName?: string
  OrganizationLogo?: string
  Name: string
  ContactInfo?: string
  Cover?: string
  PlayURLs?: string[]
  IMGroupId?: string
  IMSDKAppid?: string
  IMToken?: string
  StartTime?: string
  RoomId?: string
  Type: string // 房间类型
  StreamStatus: 0 | 1
  VisitorTimes?: number // 访问次数
  WSAddr?: string
  Token?: string
}

type LiveRoomRes = {
  Data: RoomState
  Code: number
}

type OwnState = {
  Status?: PlayerStatus
  RoomExist: boolean
  OnlinePlayers?: number // 在线观众人数
}

type UserState = {
  role?: string
  username?: string
  nickname?: string
}

export enum PlayType {
  free = 1,
  roomKey = 2,
  userKey = 3,
}

export enum PlayerStatus {
  stop = 0,
  living = 1,
  noStart = 2,
  late = 3,
}

export type PlayRoomReq = {
  RoomId: string
  Type: PlayType
  PlayKey?: string
  Username?: string
  Userkey?: string
}

type InitFactory = {
  getBasicInfo?: (props: PlayRoomReq) => Promise<any>
}

export type InitState = RoomState & OwnState & UserState & InitFactory

function parseOnlineNumbers(data: string) {
  const onlineNumbers = data.slice(3)
  return onlineNumbers ? Number(onlineNumbers) : 0
}
const initBasicState: InitState = {
  RoomId: "",
  Type: "",
  Status: PlayerStatus.noStart,
  StreamStatus: 0,
  IMGroupId: "",
  IMSDKAppid: "",
  IMToken: "",
  OrganizationLogo: "",
  OrganizationName: "",
  Cover: "",
  ContactInfo: "",
  PlayURLs: [],
  StartTime: "",
  RoomExist: false,
  Name: "",
  OnlinePlayers: 0,
  VisitorTimes: 0, // 访问次数

  role: "",
  username: "",
  nickname: "",
}

export const useBasicStore = create<InitState>()(
  devtools((set) => ({
    ...initBasicState,
    getBasicInfo: async (props) => {
      if (props) {
        // 1. 获取数据
        const { Data, Code } = (await fetchResource(
          "https://api.txelive.com/api/get_play_room_info",
          "POST",
          {
            RoomId: props?.RoomId,
            Type: props?.Type,
          } as any,
        )) as LiveRoomRes
        if (!Code || Code === 5) {
          const { WSAddr, Token } = Data as RoomState
          const userInfo = jwtDecode<any>(Token as string)
          // 2. 从Token中获取role、username、nickname
          const initState: InitState = {
            ...Data,
            role: userInfo.role,
            username: userInfo.username,
            nickname: userInfo.nickname,
            // 3. 根据开始时间判断直播状态
            Status:
              Data.StreamStatus === 1
                ? PlayerStatus.living
                : moment(Data.StartTime) < moment()
                  ? PlayerStatus.stop
                  : moment(Data.StartTime).diff(moment(), "h") > 48
                    ? PlayerStatus.late
                    : PlayerStatus.noStart,
            RoomExist: Code === 0 || Code === 5,
          }
          // 4. 赋值
          set(initState)
          // 5. 初始化websocket
          const iws: any = IWebSocket.getInstance({
            token: Token,
            url: WSAddr,
            init: () => {
              iws.emit("DescribeOnlineNumber", "101")
              // 监听通用事件
              iws.on("CommonEvent", (data: any) => {
                // DescribeOnlinePlayerNumber
                if (String(data).includes("102")) {
                  const onlineNumber = parseOnlineNumbers(data)
                  set({
                    OnlinePlayers: onlineNumber,
                  })
                }
                if (String(data).includes("153")) {
                  set({ Status: PlayerStatus.living })
                }
                if (String(data).includes("154")) {
                  set({ Status: PlayerStatus.stop })
                }
              })
            },
          })
          return initState
        }
      }
    },
  })),
)
